import React from 'react';

import { UnappliedFundsBannerVariant } from '../UnappliedFundsBanner.types';

import UnappliedFundsHomeBanner from './UnappliedFundsHomeBanner';
import UnappliedFundsInlineBanner from './UnappliedFundsInlineBanner';

interface Props {
  variant: UnappliedFundsBannerVariant;
  amount: number;
  top?: string;
  isOrganizationsList: boolean;
  organizationNames: string[];
  organizationsCount: number;
  onViewOrganizations: () => void;
  onViewDetails: () => void;
}

const UnappliedFundsBanner: React.FC<Props> = ({ variant, organizationNames, top, ...rest }) =>
  variant === UnappliedFundsBannerVariant.HOME ? (
    <UnappliedFundsHomeBanner top={top} {...rest} />
  ) : (
    <UnappliedFundsInlineBanner organizationNames={organizationNames} {...rest} />
  );

export default UnappliedFundsBanner;
